<template>
  <div class="body" style="overflow: hidden;">
    <div class="main" style="max-width:1000px; margin: 0 auto;">
    <img v-if="lang != ''" :src="require('../assets/entry/img/tit' + lang + '.png')" alt=""  style="margin-top: 1.5rem;width: 65%; display:block; margin:auto;margin-bottom: 1.5rem;">
        <div class="container" style="overflow-y:auto;">
        <div v-if="eventStatus">
          <div v-for="item in entryData" v-bind:key="item.PEid">
            <!-- 内容 -->
            <div>
              <a :href="item.Url" target="_blank">
                <img v-if="item.BannerImg == ''" :src="require('../assets/entry/img/banner.png')" alt="" width="100%" data-bs-toggle="modal" data-bs-target="#exampleModalToggle">
                <img v-else :src="item.BannerImg" alt="" width="100%" data-bs-toggle="modal" data-bs-target="#exampleModalToggle">
              </a>
            </div>
            <div class="row col-md-12">
              <!-- <div class="col-md-5 pt-2 d-none d-md-block" style="text-align: center;">
                <h3 class="color_text">{{ $t('turn.EventsTime')}}</h3>
                <div>
                  <div class="color_text">
                    <p>{{ item.StartTime }}{{ item.StartTime1 }}</p>
                  </div>
                  <div>
                    <h5 style="padding: 5px;">{{ $t('turn.to')}}</h5>
                  </div>
                  <div class="color_text">
                    <p>{{ item.EndTime }}{{ item.EndTime1 }}</p>
                  </div>
                </div>
              </div> -->
              <!-- <div class="col-md-7 pt-2 d-none d-md-block" style="text-align: center;">
                <h3 style="text-align: center;">{{ $t('turn.EventsActivities')}}</h3>
                <h5 style="font-weight: bold;line-height: 1.5;">
                  <div v-html="item.Description"></div>
                </h5>
              </div> -->

            </div>
            <!--手機顯示-->
            <div class="row col-md-12">
              <div class="container pt-2 d-lg-none d-md-none d-xl-none" style="text-align: center;">
                <!-- <h2 class="color_text">{{ $t('turn.EventsTime')}}</h2>
                <div style="display: flex;justify-content: center;  align-items: center;">
                  <div class="color_text">
                    <p>{{ item.StartTime }}{{ item.StartTime1 }}</p>
                  </div>
                  <div>
                    <h5 style="padding: 5px;">{{ $t('turn.to')}}</h5>
                  </div>
                  <div class="color_text">
                    <p>{{ item.EndTime }}{{ item.EndTime1 }}</p>
                  </div>
                </div>

                <div>
                  <h2 style="text-align: center;">{{ $t('turn.EventsActivities')}}</h2>
                  <h5 style="font-weight: bold;line-height: 1.5;">
                    <div v-html="item.Description"></div>
                  </h5>
                </div> -->
              </div>

            </div>
            <!--手機顯示end-->
          </div>
        </div>
        <div v-else>
          <!-- <div class="modal fade modal_bouns" id="exampleModalToggle" aria-hidden="true" -->
              <!-- aria-labelledby="exampleModalToggleLabel" tabindex="-1"> -->
              <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                      <div class="modal-header">
                      </div>
                      <div class="modal-body">
                        <div class="money_cover">
                            <div class="money_text">
                                <p>{{ $t('turn.UnderConstruction') }}</p>
                                <p>{{ $t('turn.StartlookIt') }}</p>
                            </div>
                        </div>
                      </div>
                  </div>
              </div>
          <!-- </div> -->
        </div>
        </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      check: true,
      eventStatus: true,
      eventsData:[],
      eventsStime: "",
      eventsEtime: "",
      startTime: "",
      endTime: "",
      url: '',
      url2: '',
      status: '',
      entryData: [],
      lang: "",
      userInformationData: {
        user: "",
        token: "",
        platform: ""
      },
    };
  },
  mounted() {
    this.entryInit(this.$route.query.token)
    this.getEvents()
  },
  methods: {
    entryInit(token) {
      this.userInformationData.token = token
    },
    async getEvents() {

      this.rolling = true;
      let postData = {
        Token: this.userInformationData.token,
      }
      await fetch('/api/getEntryEvents',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.code == "200") {
            this.lang = res.lang
            this.$i18n.locale = res.lang;
            this.entryData = res.data
            if (res.data) {
              this.eventStatus = true
              const timestamp = Date.now()
              this.entryData.forEach(element => {
                let st = ""
                let et = ""
                this.startTime = element.StartTime.split(' ')
                element.StartTime1 = this.startTime[1] + " (GMT+" + element.TimeZone + ")"
                this.endTime = element.EndTime.split(' ')
                element.EndTime1 = this.endTime[1] + " (GMT+" + element.TimeZone + ")"
                if (this.lang == "zh-tw") {
                  st = this.startTime[0].substring(0, 4) + "年" + this.startTime[0].substring(5, 7) + "月" + this.startTime[0].substring(8, 10) + "日"
                  et = this.endTime[0].substring(0, 4) + "年" + this.endTime[0].substring(5, 7) + "月" + this.endTime[0].substring(8, 10) + "日"
                } else {
                  let sdate = new Date(element.StartTime)
                  let enSDate = sdate.toDateString()
                  let enStartDateArray = enSDate.split(' ')
                  st = `${enStartDateArray[1]} ${enStartDateArray[2]}, ${enStartDateArray[3]}`
                  let edate = new Date(element.EndTime)
                  let enEDate = edate.toDateString()
                  let enEndDateArray = enEDate.split(' ')
                  et = `${enEndDateArray[1]} ${enEndDateArray[2]}, ${enEndDateArray[3]}`
                }
                element.StartTime = st
                element.EndTime = et
                element.Url = "lottery?token=" + postData.Token + "&peid=" + element.PEid
                if (element.BannerImg && element.BannerImg !== "") {
                  const separator = element.BannerImg.indexOf("?") > -1 ? "&" : "?"
                  element.BannerImg = element.BannerImg + separator + "v=" + timestamp
                }
              });
            }else{
              this.eventStatus = false
            }
          } else {
            this.$message.error(this.$t('turn.' + res.data));
            this.rolling = false;
          }
        })
    },
    Date() {
      const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
        hours: nowDate.getHours(),
        minutes: nowDate.getMinutes(),
        seconds: nowDate.getSeconds(),
      };

      const newmonth = date.month >= 10 ? date.month : "0" + date.month;
      const newday = date.date >= 10 ? date.date : "0" + date.date;
      return date.year + "-" + newmonth + "-" + newday;
    }
  }
}
</script>
<style scoped>

@import '../assets/entry/css/style.css';
@import '../assets/hongbao/css/animate.css';
@import '../assets/hongbao/css/bootstrap.css';
</style>



// WEBPACK FOOTER //
// src/components/entry.vue